// @flow
import { pickBy } from 'lodash'

export const getArticleMedias = (state: Object, articleId: string): Object => {
  return pickBy(state.articleMedias.resources, (articleMedia) => articleMedia.article === articleId)
}
